"use strict";

require("core-js/modules/es.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BasicModal.default;
  }
});
Object.defineProperty(exports, "BasicModal", {
  enumerable: true,
  get: function get() {
    return _BasicModal.default;
  }
});
Object.defineProperty(exports, "BaseModal", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
exports.alert = exports.confirm = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _react = _interopRequireDefault(require("react"));

var _Confirm = _interopRequireDefault(require("./Confirm"));

var _Alert = _interopRequireDefault(require("./Alert"));

var _BasicModal = _interopRequireDefault(require("./BasicModal"));

var _Modal = _interopRequireDefault(require("./Modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Pretty Confirm
 * @param options
 */
var confirm = function confirm(options) {
  var ele = window.document.createElement('div');
  window.document.body.appendChild(ele);

  var _destroy = function _destroy() {
    _reactDom.default.unmountComponentAtNode(ele);

    window.document.body.removeChild(ele);
  };

  var _handleConfirm = function _handleConfirm() {
    _destroy();

    options.onConfirm && options.onConfirm();
  };

  var _handleCancel = function _handleCancel() {
    _destroy();

    options.onCancel && options.onCancel();
  };

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_Confirm.default, _extends({}, options, {
    onConfirm: _handleConfirm,
    onCancel: _handleCancel
  })), ele);
};
/**
 * Pretty Alert
 * @param options
 */


exports.confirm = confirm;

var alert = function alert(options) {
  var ele = window.document.createElement('div');
  window.document.body.appendChild(ele);

  var _destroy = function _destroy() {
    _reactDom.default.unmountComponentAtNode(ele);

    window.document.body.removeChild(ele);
  };

  var _handleProceed = function _handleProceed() {
    _destroy();

    options.onProceed && options.onProceed();
  };

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_Alert.default, _extends({}, options, {
    onProceed: _handleProceed
  })), ele);
};

exports.alert = alert;
//# sourceMappingURL=index.js.map